export default __webpack_public_path__ + "static/media/xlsx.1d34b08c.svg";